export default __webpack_public_path__ + "static/media/Aura-Egg__24.fab9b3f0.png";